import { memo } from "react";

function PossibleMerge() {
  return (
    <svg
      width="13"
      height="16"
      viewBox="0 0 13 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.8067 11.2143L5.37788 12.6431C5.14965 12.8713 5.14965 13.2414 5.37788 13.4696C5.6061 13.6978 5.97615 13.6978 6.20438 13.4696L8.68388 10.9901C8.9121 10.7619 8.9121 10.3918 8.68388 10.1636L6.20438 7.68418C5.97615 7.45595 5.6061 7.45595 5.37788 7.68418C5.14965 7.9124 5.14965 8.28245 5.37788 8.51067L6.91275 10.0455H1.75325C1.43048 10.0455 1.16883 9.7838 1.16883 9.46108V2.25324C1.16883 1.93048 1.43048 1.66883 1.75325 1.66883H8.76623C9.08903 1.66883 9.35063 1.40718 9.35063 1.08442C9.35063 0.761653 9.08903 0.5 8.76623 0.5H1.75325C0.784957 0.5 0 1.28496 0 2.25324V9.46108C0 10.4293 0.784957 11.2143 1.75325 11.2143H6.8067Z"
        fill="#666666"
      />
      <path
        d="M4.48055 4.3954C4.15778 4.3954 3.89613 4.65704 3.89613 4.97981V8.29149C3.89613 8.61429 3.63448 8.87589 3.31171 8.87589C2.98895 8.87589 2.72729 8.61429 2.72729 8.29149V4.97981C2.72729 4.01152 3.51225 3.22656 4.48055 3.22656H10.7143C11.6826 3.22656 12.4676 4.01152 12.4676 4.97981V13.746C12.4676 14.7143 11.6826 15.4993 10.7143 15.4993H4.48055C3.51225 15.4993 2.72729 14.7143 2.72729 13.746V12.772C2.72729 12.4493 2.98895 12.1876 3.31171 12.1876C3.63448 12.1876 3.89613 12.4493 3.89613 12.772V13.746C3.89613 14.0688 4.15778 14.3305 4.48055 14.3305H10.7143C11.0371 14.3305 11.2987 14.0688 11.2987 13.746V4.97981C11.2987 4.65704 11.0371 4.3954 10.7143 4.3954H4.48055Z"
        fill="#666666"
      />
    </svg>
  );
}

export default memo(PossibleMerge);
